<template>
    <ul>
        <li v-for="(item, index) in list" :key="index" :class="['stage-' + item.stage]">
            <i v-if="item.stage === 2"><svg-icon name="yes-2" /></i>
            <i v-else>{{ index + 1 }}</i>
            <div class="box">
                <div class="title" @click="item.is_show = !item.is_show">
                    <h3 v-if="item.stage === 0" class="toogle" v-html="item.title">
                    </h3>
                    <h3 v-else v-html="item.title"></h3>
                    <div :class="['toogle-btn', item.is_show && 'toogle-btn-close']">
                        <svg-icon name="next" />
                    </div>
                </div>
                <slide-up-down v-if="item.stage !== 2" v-model="item.is_show" :duration="300">
                    <p v-html="item.text"></p>
                </slide-up-down>
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'CreatorCards',

    data() {
        return {
            list: [
                {
                    stage: 1,
                    is_show: true,
                    title: 'Add individual creators',
                    text: 'Add your creator partners one-by-one or by uploading a CSV to enable them to create a personalized storefront.',
                },
                {
                    stage: 0,
                    is_show: false,
                    title: 'Invite your partners',
                    text: `Share your unique Anchor invite link with the creators you added in Step 1. We've included an optional email template you can use that includes creator instructions. Once a creator has joined Motom and connected the social handle you provided, they will be able to create their personalized storefront.`,
                },
                {
                    stage: 0,
                    is_show: false,
                    title: 'Track status',
                    text: `The Creator Management tab in your Anchor portal will update each creator's status when they create a Motom account so you can remind them if a campaign deadline is approaching. If they have any questions, they can reach out to Motom's Creator Success team directly at <a href="mailto:creators@motom.me">creators@motom.me</a>.`,
                    // text: `The Creator Management tab in your Anchor portal will update each creator's status when they create a Motom account so you can remind them if a campaign deadline is approaching. If they have any questions, they can reach out to Motom's Creator Success team directly at <a href="javascript:void(0);" class="notify-link">creators@motom.me</a>.`,
                },
                {
                    stage: 0,
                    is_show: false,
                    title: 'Analyze and optimize performance',
                    text: 'Once a creator launches their storefront, you can see detailed analytics on the views, clicks, sales, and sales value each creator generates. You can also disable individual creators as needed.',
                },
            ],

        }
    },

    mounted() {
        this.EventBus.off('update-import-stage');
        this.EventBus.on('update-import-stage', (stage) => {
            console.log('stage',stage)
            switch (stage) {
                case 0:
                    this.list[0].stage = 1;
                    this.list[0].is_show = true;
                    this.list[1].stage = 0;
                    this.list[1].is_show = true;
                    this.list[2].stage = 0;
                    this.list[2].is_show = false;
                    this.list[3].stage = 0;
                    this.list[3].is_show = false;
                    break;
                case 1:
                    this.list[0].stage = 2;
                    this.list[0].is_show = false;
                    this.list[1].stage = 1;
                    this.list[1].is_show = true;
                    this.list[2].stage = 0;
                    this.list[2].is_show = true;
                    this.list[3].stage = 0;
                    this.list[3].is_show = false;
                    break;
                case 2:
                    this.list[0].stage = 2;
                    this.list[0].is_show = false;
                    this.list[1].stage = 2;
                    this.list[1].is_show = false;
                    this.list[2].stage = 2;
                    this.list[2].is_show = false;
                    this.list[3].stage = 1;
                    this.list[3].is_show = true;
                    break;
                // case 3:
                //     this.list[0].stage = 2;
                //     this.list[0].is_show = false;
                //     this.list[1].stage = 2;
                //     this.list[1].is_show = false;
                //     this.list[2].stage = 2;
                //     this.list[2].is_show = true;
                //     this.list[3].stage = 1;
                //     this.list[3].is_show = true;
                //     break;        
            }
        });

        // document.addEventListener('click', (e) => {
        //     if (e.target.classList.contains('notify-link')) {
        //         this.$router.push('/help');
        //     }
        // });
    },
}
</script>
<style lang="scss" scoped>
// .heading {
//     min-height: 32px;
//     padding: 0 0 16px;
//     z-index: 3;
// }
ul {
    position: relative;
    padding-left: 52px;
    margin: 24px 0;

    &::after {
        content: '';
        position: absolute;
        left: 18px;
        width: 4px;
        top: 22px;
        bottom: 22px;
        background-color: var(--black-20);
    }
}

li {
    // background-color: var(--bg-02);
    border-radius: 8px;
    position: relative;
    padding-bottom: 40px;

    &:last-child {

        &::before {
            content: '';
            position: absolute;
            z-index: 2;
            top: 22px;
            left: -52px;
            width: 40px;
            bottom: 0;
            background-color: white !important;
        }

    }

    i {
        position: absolute;
        left: -52px;
        top: 0;
        height: 38px;
        width: 38px;
        border-radius: 20px;
        font: var(--font-fg-16);
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--dark-blue);
        background-color: white;
        border: 1px solid var(--black-20);
        background-color: #fbfbfb;
        z-index: 3;
    }

    h3 {
        font: var(--font-fg-16);
        color: var(--dark-blue);
        padding: 8px 0;
        min-height: 38px;
        // line-height: 38px;

        &.toogle {
            cursor: pointer;
        }
    }

    p {
        color: var(--black-90);
        margin: 0 0 0;
        padding-bottom: 12px;
    }

    .box {
        padding: 0 12px;
        border: 1px solid var(--border);
        border-radius: 8px;

        .title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;

            .toogle-btn {
                svg {
                    height: 12px;
                    width: 12px;
                    transform: rotate(90deg);
                    color: var(--black-50);
                }
            }

            .toogle-btn-close {
                svg {
                    transform: rotate(-90deg);
                }
            }
        }


    }

    &.stage-1 {
        &::before {
            position: absolute;
            left: -34px;
            width: 4px;
            top: 20px;
            bottom: -10px;
            z-index: 1;
            background-color: #CBD4E1;
            content: '';
        }

        i {
            background-color: var(--border);
            border-color: var(--border);
        }

        .box {
            background-color: var(--bg-02);
            border-color: var(--bg-02);
        }
    }

    &.stage-2 {
        &::before {
            position: absolute;
            left: -34px;
            width: 4px;
            top: 20px;
            bottom: -10px;
            z-index: 1;
            background-color: #48C79C;
            content: '';
        }

        i {
            background-color: #A5E1BF;
            border-color: #A5E1BF;

            svg {
                height: 9px;
                width: 12px;
                fill: var(--dark-blue);
            }
        }

        .box {
            background-color: white;
            border-color: white;
        }
    }
}
</style>

